var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExplorium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 76,
    viewBox: "0 0 237 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.367371,
    y: 0.000244141,
    width: 236.335,
    height: 75.9997,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1900_18313",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 22,
    width: 146,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.703 22.4932H71.5976V53.785H216.703V22.4932Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1900_18313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.8467 44.16C82.8795 44.16 84.4041 43.2516 85.2171 42.0745L88.2316 43.8251C86.6724 46.1124 84.1316 47.4913 80.8122 47.4913C75.2221 47.4913 71.5978 43.6897 71.5978 38.6422C71.5978 33.5948 75.2221 29.7932 80.5419 29.7932C85.8616 29.7932 89.0448 33.8311 89.0448 38.6766C89.0448 39.1815 88.9777 39.7206 88.9085 40.1909H75.4253C76.0005 42.8156 78.1349 44.16 80.8445 44.16H80.8467ZM85.3511 37.229C84.8429 34.3359 82.7086 33.0901 80.5073 33.0901C77.7631 33.0901 75.9012 34.7052 75.3929 37.229H85.3511Z",
    fill: "#2C4546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.091 47.0553L97.8919 41.3012L93.6577 47.0553H89.389L95.7575 38.408L89.7285 30.2312H93.9626L97.8572 35.547L101.754 30.2312H106.023L99.9939 38.4402L106.328 47.0529H102.094L102.091 47.0553Z",
    fill: "#2C4546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.059 22.4934H131.718V47.056H128.059V22.4934Z",
    fill: "#2C4546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.08 38.6422C134.08 33.6293 138.076 29.7932 143.024 29.7932C147.971 29.7932 151.968 33.6293 151.968 38.6422C151.968 43.6553 148.004 47.4913 143.024 47.4913C138.043 47.4913 134.08 43.6209 134.08 38.6422ZM148.306 38.6422C148.306 35.5793 146.003 33.3264 143.021 33.3264C140.039 33.3264 137.736 35.5817 137.736 38.6422C137.736 41.7028 140.039 43.9581 143.021 43.9581C146.003 43.9581 148.306 41.7028 148.306 38.6422Z",
    fill: "#2C4546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.023 39.0802V47.0553H157.682V39.0802C157.682 36.0174 159.985 33.7643 162.967 33.7643V30.2312C158.022 30.2312 154.023 34.0673 154.023 39.0802Z",
    fill: "#2C4546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.252 30.2312H168.91V47.0553H165.252V30.2312Z",
    fill: "#2C4546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.654 29.7936C111.708 29.7936 107.71 33.6296 107.71 38.6426V53.7827H111.368V45.8076C112.849 46.87 114.674 47.4893 116.654 47.4893C121.634 47.4893 125.597 43.6189 125.597 38.6404C125.597 33.6617 121.634 29.7913 116.654 29.7913V29.7936ZM116.654 43.9585C113.671 43.9585 111.368 41.7032 111.368 38.6426C111.368 35.582 113.671 33.3268 116.654 33.3268C119.636 33.3268 121.939 35.582 121.939 38.6426C121.939 41.7032 119.636 43.9585 116.654 43.9585Z",
    fill: "#2C4546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.385 30.2312V39.8374C183.385 42.0582 181.572 43.8593 179.336 43.8593C177.099 43.8593 175.287 42.0582 175.287 39.8374V30.2312H171.63V39.8374C171.63 44.0658 175.08 47.4912 179.336 47.4912C183.592 47.4912 187.041 44.0635 187.041 39.8374V30.2312H183.382H183.385Z",
    fill: "#2C4546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.997 29.8121C206.652 29.8121 204.555 30.8537 203.142 32.4918C201.728 30.8308 199.617 29.7754 197.255 29.7754C192.999 29.7754 189.55 33.2031 189.55 37.4291V47.0354H193.209V37.4291C193.209 35.2083 195.022 33.4072 197.258 33.4072C199.494 33.4072 201.201 35.112 201.298 37.2479C201.298 37.319 201.294 37.3924 201.294 37.4658V47.072H204.952V47.0376H204.966V37.4315C204.966 37.3786 204.964 37.3237 204.961 37.2708C205.066 35.1418 206.83 33.4439 208.998 33.4439C211.168 33.4439 213.048 35.245 213.048 37.4658V47.072H216.705V37.4658C216.705 33.2375 213.253 29.8121 208.997 29.8121Z",
    fill: "#2C4546"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3674 20.0002L37.2185 36.8802V20.0002H20.3674Z",
    fill: "#54B092"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6783 26.269L57.6731 31.3485L62.7525 31.3433L57.6783 26.269Z",
    fill: "#F8AA60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5303 20.7927V37.6937C40.7384 37.6176 42.8939 37.1509 44.9419 36.3012C46.9926 35.4515 48.8465 34.2557 50.4594 32.7427L38.5303 20.7927Z",
    fill: "#62CCA9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5303 40.0483V56L46.4917 48.0255L38.5303 40.0483Z",
    fill: "#62CCA9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3873 33.6699L51.3559 33.6987C49.6278 35.3167 47.6374 36.6016 45.4425 37.5116C43.4731 38.3271 41.4094 38.8149 39.2985 38.9618L47.37 47.0464L56.0551 38.3454L51.3848 33.6672L51.3873 33.6699Z",
    fill: "#54B092"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.187 26.269L48.5411 28.9176L56.5051 36.8921L56.5025 26.269H51.187Z",
    fill: "#62CCA9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorium);
export default __webpack_public_path__ + "static/media/explorium.712bb9e0afb670e9da4bb8fb5af7c366.svg";
export { ForwardRef as ReactComponent };